"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _joi = require('@hookform/resolvers/joi');
var _joi3 = require('shared/services/validation/joi'); var _joi4 = _interopRequireDefault(_joi3);

// The reason staff give when marking a patient opted out of texts or
// resubscribing them. The backend trims it and allows at most 500 characters.
 const SMS_PREFERENCE_REASON_MAX_LENGTH = 500; exports.SMS_PREFERENCE_REASON_MAX_LENGTH = SMS_PREFERENCE_REASON_MAX_LENGTH





const schema = _joi4.default.object({
  reason: _joi3.requiredString.call(void 0, )
    .trim()
    .max(exports.SMS_PREFERENCE_REASON_MAX_LENGTH)
    .messages(_joi3.makeStrErrors.call(void 0, 'Reason')),
})

 const smsPreferenceReasonResolver = _joi.joiResolver.call(void 0, schema); exports.smsPreferenceReasonResolver = smsPreferenceReasonResolver
